<template>
  <toaster @close-toaster="closeSummaryToaster">
    <template v-slot:text>
      <span>צפי ההוצאות על <span class="bold">{{ categoryName }}</span> ב{{ timeFrameTitle }} התעדכן</span>
    </template>
  </toaster>
</template>

<script>
import EventBus from '@/event-bus/event-bus';
import Toaster from '../../../../../../base-components/Toaster';

export default {
  name: 'EditCategoryAmountToaster',
  components: {
    Toaster,
  },
  props: {
    categoryName: {
      type: String,
      required: true,
    },
    timeFrameTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeSummaryToaster() {
      EventBus.$emit('close-toaster');
    },
  },
};
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
</style>
